export default "__VITE_ASSET__BSfTx0Jl__"